import { render } from "./QuestionsList.vue?vue&type=template&id=2ae5259c&scoped=true"
import script from "./QuestionsList.vue?vue&type=script&lang=js"
export * from "./QuestionsList.vue?vue&type=script&lang=js"

import "./QuestionsList.vue?vue&type=style&index=0&id=2ae5259c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ae5259c"]])

export default __exports__